{
  "english": "EN",
  "german": "DE",
  "guide": "Anleitung",
  "guideTitle": "Die Hilfe zu DMW öffnen",
  "language": "Sprache",
  "theme": "Design",
  "themeDark": "Dunkel",
  "themeLight": "Hell",
  "themeNeon": "Neon",
  "themeRetro": "Retro",
  "title": "DMW",
  "toHome": "Zu den Dokumenten",
  "toLanding": "Zur Startseite",
  "toLogin": "Zur Anmeldung"
}
